module.exports = __webpack_public_path__ + "img/fancy@2x.6c9a79c.webp";